import type { IntegrationProviderConfig } from '../../types';
import MicrosoftConnectionCard from './MicrosoftConnectionCard';
import MicrosoftIcon from './MicrosoftIcon';

export const microsoftConfig: IntegrationProviderConfig = {
  id: 'microsoft',
  name: 'Microsoft 365',
  icon: MicrosoftIcon,
  brandColor: '#0078D4',
  authMethod: 'oauth2',
  ConnectionCard: MicrosoftConnectionCard,
  supportsPull: false,
  supportsPush: false,
  description:
    'Work with Word, Excel, PowerPoint, and OneDrive through your Microsoft 365 account.',
  category: ['productivity', 'storage'],
  keywords: ['office', 'excel', 'word', 'powerpoint', 'onedrive', 'outlook'],
  docsUrl: 'https://learn.microsoft.com/en-us/graph/overview',
  priority: 87,
  supportsSharing: true,
};
